var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FilterComp',{attrs:{"info":"false","id":_vm.id},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(index,name){return {key:name,fn:function(data){return [_vm._t(name,null,{"showFilter":_vm.showFilter},data)]}}})],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }